<template>
  <section class="section login">
    <form class="login-form" @submit.prevent="login(email, password, hpField)">
      <h1>{{ $t('login.title') }}</h1>

      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

      <input v-model="email" type="email" :placeholder="$t('login.email')" required />
      <input v-model="password" type="password" :placeholder="$t('login.password')" required />

      <!-- Honeypot input (gizli) -->
      <input 
        v-model="hpField"
        type="text"
        autocomplete="off"
        tabindex="-1"
        class="honeypot"
        aria-hidden="true"
      />

      <button class="btn">{{ $t('login.button') }}</button>

      <!-- Şifremi Unuttum bağlantısı -->
      <p class="forgot-link">
        <router-link to="/forgot-password">{{ $t('login.forgotPassword') }}</router-link>
      </p>

      <p class="register-link">
        {{ $t('login.noAccount') }}
        <router-link to="/register">{{ $t('login.register') }}</router-link>
      </p>
    </form>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { setAuth } from '@/utils/auth'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const email = ref('')
const password = ref('')
const hpField = ref('') // honeypot alanı
const baseURL = process.env.VUE_APP_API_URL
const errorMessage = ref('')

async function login(email, password, hpField) {
  errorMessage.value = ''

  const res = await fetch(`${baseURL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, hp: hpField }) // honeypot alanı da gönderiliyor
  })

  const data = await res.json()

  if (res.ok) {
    setAuth(data.token, data.user)
    const redirect = route.query.redirect || '/'
    router.push(redirect)
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('login-success'))
    }, 100)
  } else {
    errorMessage.value = data.message || t('login.error')
  }
}
</script>

<style scoped>
/* 👤 Honeypot alanı görünmez */
.honeypot {
  position: absolute;
  left: -9999px;
  opacity: 0;
  height: 0;
  pointer-events: none;
}
.section.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;  
  position: relative;
  padding: 100px 20px 40px;
}
.login-form {
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.login-form h1 {
  text-align: center;
  font-size: 28px;
  margin-bottom: 10px;
  color: #0c2d57;
}

.login-form input {
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 15px;
}

.login-form input:focus {
  outline: none;
  border-color: #0c2d57;
  box-shadow: 0 0 0 2px rgba(12, 45, 87, 0.2);
}

.btn {
  background-color: #0c2d57;
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #09203f;
}

.register-link {
  text-align: center;
  font-size: 14px;
}

.register-link a {
  color: #0c2d57;
  font-weight: 600;
  text-decoration: none;
}

.register-link a:hover {
  text-decoration: underline;
}
.error-message {
  color: #c0392b;
  background-color: #fce4e4;
  padding: 10px;
  border-radius: 6px;
  text-align: center;
  font-weight: 500;
  border: 1px solid #e0b4b4;
}
.forgot-link {
  text-align: center;
  font-size: 14px;
  margin-top: -10px;
}

.forgot-link a {
  color: #0c2d57;
  font-weight: 500;
  text-decoration: none;
}

.forgot-link a:hover {
  text-decoration: underline;
}
@media (max-width: 600px) {
  .login-form {
    padding: 24px 20px;
    border-radius: 12px;
    gap: 16px;
  }

  .login-form h1 {
    font-size: 22px;
  }

  .login-form input {
    font-size: 14px;
    padding: 10px 14px;
  }

  .btn {
    font-size: 14px;
    padding: 10px;
  }

  .register-link,
  .forgot-link {
    font-size: 13px;
  }

  .error-message {
    font-size: 13px;
    padding: 8px;
  }
}
</style>
